/**
 * Building Type Context.
 *
 * Provides the current building type configuration to all unified
 * assessment screens via React Context.
 *
 * Usage:
 *   <BuildingTypeProvider type="healthcare">
 *     <Dashboard />
 *   </BuildingTypeProvider>
 *
 *   const config = useBuildingConfig();
 *   // config.points.name === 'HDPS'
 *   // config.spaceTypes === [...]
 */

import React, { useContext, useMemo } from 'react';
import { getBuildingConfig } from './configs';

const BuildingTypeContext = React.createContext(null);

export const BuildingTypeProvider = ({ type, children }) => {
  const config = useMemo(() => getBuildingConfig(type), [type]);
  return (
    <BuildingTypeContext.Provider value={config}>
      {children}
    </BuildingTypeContext.Provider>
  );
};

export const useBuildingConfig = () => {
  const config = useContext(BuildingTypeContext);
  if (!config) {
    throw new Error('useBuildingConfig must be used within a BuildingTypeProvider');
  }
  return config;
};

export default BuildingTypeContext;
